import { useEffect } from "react";
import { runSyncPass, queueCounts } from "../lib/photoQueue";
import { API_BASE } from "../lib/api";

/**
 * Hintergrund-Worker: läuft wenn die App offen ist.
 * - Bei Mount
 * - Auf `online` Event
 * - Alle 30 Sekunden
 * Aktualisiert einen Callback mit Queue-Counts.
 */
export function usePhotoQueueWorker(onCountsChange) {
    useEffect(() => {
        let cancelled = false;

        const pass = async () => {
            if (cancelled) return;
            try {
                await runSyncPass(API_BASE);
            } catch (_e) { /* ignore */ }
            if (onCountsChange) {
                try {
                    onCountsChange(await queueCounts());
                } catch (_e) { /* ignore */ }
            }
        };

        pass();
        const iv = setInterval(pass, 30_000);
        const onOnline = () => pass();
        window.addEventListener("online", onOnline);
        return () => {
            cancelled = true;
            clearInterval(iv);
            window.removeEventListener("online", onOnline);
        };
    }, [onCountsChange]);
}
